/**
 * Background location task for Landmark Run.
 * Must be imported at the app root (App.tsx) to register before use.
 */
import * as TaskManager from 'expo-task-manager';
import * as Location from 'expo-location';
import { DeviceEventEmitter } from 'react-native';
import { appLog } from '../utils/logger';

export const LOCATION_TASK_NAME = 'landmark-run-location';
export const LOCATION_EVENT = 'landmarkRunLocationUpdate';

export type LocationEventData = {
  coords: {
    latitude: number;
    longitude: number;
    accuracy: number;
    speed: number;
  };
  timestamp: number;
};

TaskManager.defineTask(LOCATION_TASK_NAME, ({ data, error }: TaskManager.TaskManagerTaskBody) => {
  if (error) {
    appLog.error('[Task] GPS error', { message: error.message });
    return;
  }
  if (!data) {
    appLog.warn('[Task] GPS fired with no data');
    return;
  }

  const { locations } = data as { locations: Location.LocationObject[] };
  if (!locations?.length) {
    appLog.warn('[Task] GPS fired with empty locations array');
    return;
  }

  const first = locations[0];
  const ageMs = Date.now() - first.timestamp;
  appLog.info(`[Task] GPS batch ×${locations.length}`, {
    lat: first.coords.latitude.toFixed(5),
    lng: first.coords.longitude.toFixed(5),
    speedMph: (first.coords.speed * 2.237).toFixed(1),
    ageMs: Math.round(ageMs),
  });

  // Emit each location so ActiveRunScreen (foreground or background) can react
  locations.forEach((loc) => {
    DeviceEventEmitter.emit(LOCATION_EVENT, {
      coords: {
        latitude: loc.coords.latitude,
        longitude: loc.coords.longitude,
        accuracy: loc.coords.accuracy ?? 0,
        speed: loc.coords.speed ?? 0,
      },
      timestamp: loc.timestamp,
    } as LocationEventData);
  });
});
